

























































import Vue from 'vue';
import Enemy from '@/classes/enemy/enemy';

export default Vue.extend({
  name: 'EnemyTooltip',
  props: {
    value: {
      type: Enemy,
      required: true,
    },
  },
  computed: {
    armor(): number {
      let sum = 0;
      for (let i = 0; i < this.value.items.length; i += 1) {
        sum += this.value.items[i].data.armor;
      }

      return this.value.data.armor + sum;
    },
  },
});
